import React from "react";
import ileeroRemitLogo from "../../assets/images/ileero-remit-logo-2.png";
import { Nav, Navbar } from "react-bootstrap";

const LandingPageNav = () => {
  return (
    <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
      <Navbar.Brand href="/">
        <img
          src={ileeroRemitLogo}
          alt=""
          style={{ width: "150px", height: "50px", objectFit: "contain" }}
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav mr-4">
        <Nav className="ml-auto pr-5">
          <Nav.Link
            href="/about-us"
            className=" text-dark font-weight-bold mx-2"
          >
            About Us
          </Nav.Link>
          <Nav.Link
            href="/#choose-ileero-remit"
            className=" text-dark font-weight-bold mx-2"
          >
            Features
          </Nav.Link>
          <Nav.Link
            href="/#how-it-works"
            className=" text-dark font-weight-bold mx-2"
          >
            How it works
          </Nav.Link>
          <Nav.Link href="/#help" className=" text-dark font-weight-bold mx-2">
            Help
          </Nav.Link>
          <Nav.Link href="/#faqs" className=" text-dark font-weight-bold mx-2">
            FAQs
          </Nav.Link>
          <Nav.Link
            href="https://medium.com/@ileeroremit"
            className=" text-dark font-weight-bold mx-2"
          >
            Blog
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default LandingPageNav;
